import React, { useState } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  FaCashRegister,
  FaFileMedical,
  FaPenSquare,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import ProMedicine from "../Procedure Medicine/ProMedicine";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
const Income = () => {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const [searchList, setSearchList] = useState([]);

  const [proMedicineLists, setProMedicineLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showDialog = () => setOpen(true);
  // const _export = React.useRef(null);
  // const excelExport = () => {
  //   if (_export.current !== null) {
  //     console.log(_export.current.props.data);
  //     _export.current.props.data.map(function (element, index) {
  //       element.date = element.date.split("T")[0];
  //     });
  //     _export.current.save();
  //   }
  // };

  const handleDelete = (event) => {
    api
      .delete("procedure-medicine/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = proMedicineLists.filter((item) => item._id !== event);
        setProMedicineLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const submit = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to Delete this Data?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleDelete(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  const search = (val) => {
    if (val) {
      setSearchList(
        proMedicineLists.filter(
          (el) =>
            el.name.toLowerCase().includes(val.toLowerCase()) ||
            el.code.toLowerCase().includes(val.toLowerCase()) ||
            el.relatedBrand.name.toLowerCase().includes(val.toLowerCase()),
        ),
      );
      setShowSearch(true);
      setShowOri(false);
    } else {
      setShowSearch(false);
      setShowOri(true);
    }
  };

  useEffect(() => {
    const getProMedicineLists = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("procedure-medicines?limit=100");
        setProMedicineLists(res.data.list);
      } catch (err) {
        alert(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    getProMedicineLists();
  }, []);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active fs-5">
                      Procedure Medicine List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              <div className="row d-flex justify-content-between ">
                <div className="col-md-6">
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className="offset-1 col-md-4 ml-5">
                  <div
                    className="input-group row ml-5"
                    style={{ marginBottom: "20px" }}
                  >
                    <div className="col-md-6">
                      <input
                        type="search"
                        className="form-control rounded ml-4"
                        style={{ borderRadius: "12px" }}
                        id="search_code"
                        onChange={(e) => search(e.target.value)}
                        placeholder="Search"
                      />
                    </div>
                    <div className="col-md-6 mt-1">
                      <button
                        type="button"
                        className="btn  btn-primary ml-4"
                        style={{ borderRadius: "7px" }}
                        onClick={showDialog}
                      >
                        Add Item
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header">
                      <div className="row justify-content-between">
                        <span className="float-right">
                          <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a>
                           <button
                              type="button"
                              className="btn btn-primary"
                              onClick={excelExport}>
                              Export Excel
                            </button>
                        </span>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div> */}

                    <div className="card-body">
                      {/* Export data in Excel */}
                      {/* <ExcelExport data={incomeLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="relatedBankAccount.name"
                          title="Bank Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedCashAccount.name"
                          title="Cash Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedAccounting.name"
                          title="Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport> */}
                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive" id="slimtest2">
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead className="">
                                <tr>
                                  <th>#</th>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Brand</th>
                                  <th>Category</th>
                                  <th>Sub Category</th>
                                  <th>Description</th>
                                  <th className="text-center">Unit</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>

                              {showOri && (
                                <tbody className="">
                                  {isLoading ? (
                                    <tr>
                                      <td colSpan="9" className="text-center">
                                        <div
                                          class="spinner-border"
                                          role="status"
                                        >
                                          <span class="visually-hidden">
                                            Loading...
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    proMedicineLists.map(
                                      (proMedicineList, i) => (
                                        <tr key={i}>
                                          <td>{++i}</td>
                                          <td>
                                            {proMedicineList
                                              ? proMedicineList.code
                                              : ""}
                                          </td>
                                          <td>{proMedicineList?.name}</td>
                                          <td>
                                            {proMedicineList.relatedBrand?.name}
                                          </td>
                                          <td>
                                            {proMedicineList.relatedCategory
                                              ? proMedicineList.relatedCategory
                                                  ?.name
                                              : ""}
                                          </td>

                                          <td>
                                            {proMedicineList.relatedSubCategory
                                              ? proMedicineList
                                                  .relatedSubCategory?.name
                                              : ""}
                                          </td>
                                          <td>{proMedicineList.description}</td>
                                          <td className="text-center">
                                            <Link
                                              to={
                                                "/prounit/" +
                                                proMedicineList._id
                                              }
                                            >
                                              <p className="btn btn-sm btn-primary">
                                                Unit
                                              </p>
                                            </Link>
                                          </td>
                                          <td className="text-center">
                                            <div className="row">
                                              <div className="col-md-6">
                                                <Link
                                                  to={
                                                    "/proUpdate/" +
                                                    proMedicineList._id
                                                  }
                                                  className="btn btn-sm btn-warning"
                                                >
                                                  <FaRegEdit />
                                                </Link>
                                              </div>
                                              <div className="col-md-6">
                                                <button
                                                  className="btn btn-sm btn-danger"
                                                  onClick={(e) =>
                                                    submit(proMedicineList._id)
                                                  }
                                                >
                                                  <FaRegTrashAlt />
                                                </button>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      ),
                                    )
                                  )}
                                </tbody>
                              )}
                              {showSearch && (
                                <tbody className="">
                                  {searchList.map((proMedicineList, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>
                                        {proMedicineList
                                          ? proMedicineList.code
                                          : ""}
                                      </td>
                                      <td>{proMedicineList?.name}</td>
                                      <td>
                                        {proMedicineList.relatedBrand?.name}
                                      </td>
                                      <td>
                                        {proMedicineList.relatedCategory
                                          ? proMedicineList.relatedCategory
                                              ?.name
                                          : ""}
                                      </td>

                                      <td>
                                        {proMedicineList.relatedSubCategory
                                          ? proMedicineList.relatedSubCategory
                                              ?.name
                                          : ""}
                                      </td>
                                      <td>{proMedicineList.description}</td>
                                      <td className="text-center">
                                        <Link
                                          to={"/prounit/" + proMedicineList._id}
                                        >
                                          <p className="btn btn-sm btn-primary">
                                            Unit
                                          </p>
                                        </Link>
                                      </td>
                                      <td className="text-center">
                                        <div className="row">
                                          <div className="col-md-6">
                                            <Link
                                              to={
                                                "/proUpdate/" +
                                                proMedicineList._id
                                              }
                                              className="btn btn-sm btn-warning"
                                            >
                                              <FaRegEdit />
                                            </Link>
                                          </div>
                                          <div className="col-md-6">
                                            <button
                                              className="btn btn-sm btn-danger"
                                              onClick={(e) =>
                                                submit(proMedicineList._id)
                                              }
                                            >
                                              <FaRegTrashAlt />
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ProMedicine
                open={open}
                close={() => setOpen(false)}
                setProMedicineLists={setProMedicineLists}
                proMedicineLists={proMedicineLists}
              />
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Income;
